import React from 'react';

const HowItWorksSection: React.FC = () => {
  const steps = [
    {
      number: '1',
      title: 'Request a Quote',
      description: 'Fill out our simple form or give us a call to discuss your landscaping needs',
      icon: 'ri-file-list-3-line'
    },
    {
      number: '2',
      title: 'Get Your Estimate',
      description: 'Receive a detailed, transparent quote with no hidden fees',
      icon: 'ri-calculator-line'
    },
    {
      number: '3',
      title: 'Schedule Service',
      description: 'Choose a convenient time that works with your schedule',
      icon: 'ri-calendar-check-line'
    },
    {
      number: '4',
      title: 'Enjoy Your Yard',
      description: 'Sit back and relax while we transform your outdoor space',
      icon: 'ri-plant-line'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-[#83B328]/5 to-[#83B328]/10">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Getting started with J's Landscaping is simple and straightforward
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="flex flex-col items-center mb-6">
                {/* Number Badge - Above Circle */}
                <div className="bg-white border-2 border-[#83B328] text-[#83B328] w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg mb-4 shadow-md">
                  {step.number}
                </div>
                
                {/* Icon Circle */}
                <div className="bg-[#83B328]/10 w-20 h-20 rounded-full flex items-center justify-center">
                  <i className={`${step.icon} text-4xl text-[#83B328]`}></i>
                </div>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
              <p className="text-gray-600">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
